import Constants from '@/utilities/constants'
import {
  dateBetween,
  esClient
} from '@/utilities/ptracSearch'

export async function idaSearch(esCreds, query, from = 0) {
  const searchBody = assembleElasticsearchQuery(query, Constants.ELASTICSEARCH.MAX_SEARCH_RESULTS, from)

  if (Constants.ENVIRONMENTS.PRODUCTION !== process.env.VUE_APP_ENV) {
    console.log(JSON.stringify(searchBody, null, 2))
  }

  return await esClient(esCreds).search({
    index: 'web-inspections',
    body: searchBody
  })
}

export function assembleElasticsearchQuery(stateQuery, maxResults, from = 0) {
  const searchBody = {
    from,
    size: maxResults,
    query: {
      bool: {
        must: [
          {match: {_class: 'com.ats.ptrac.entity.search.ida.IdaInspectionRequest'}}
        ],
        filter: []
      }
    }
  }

  // IDA ID field
  if (stateQuery.idaId != null) {
    searchBody.query.bool.must.push({match_phrase: {idaId: stateQuery.idaId}})
  }

  if (stateQuery.invoiceNumber != null) {
    searchBody.query.bool.must.push({match_phrase: {invoiceNumber: stateQuery.invoiceNumber}})
  }

  if (stateQuery.price != null) {
    searchBody.query.bool.must.push({match_phrase: {price: stateQuery.price}})
  }

  // Client field
  if (stateQuery.idaClientName != null) {
    searchBody.query.bool.must.push({match_phrase: {clientName: stateQuery.idaClientName}})
  }

  // Builder field
  if (stateQuery.idaBuilderName != null) {
    searchBody.query.bool.must.push({match_phrase: {builderName: stateQuery.idaBuilderName}})
  }

  // Subdivision field
  if (stateQuery.idaSubdivisionName != null) {
    searchBody.query.bool.must.push({match_phrase: {subdivisionName: stateQuery.idaSubdivisionName}})
  }

  // Street name field
  if (stateQuery.idaStreetName != null) {
    searchBody.query.bool.must.push({match_phrase: {streetName: stateQuery.idaStreetName}})
  }

  // Street number field
  if (stateQuery.streetNumber != null) {
    searchBody.query.bool.must.push({match_phrase: {streetNumber: stateQuery.streetNumber}})
  }

  // City field
  if (stateQuery.idaCity != null) {
    searchBody.query.bool.must.push({match_phrase: {city: stateQuery.idaCity}})
  }

  // State field
  if (stateQuery.state != null) {
    searchBody.query.bool.must.push({match_phrase: {state: stateQuery.state}})
  }

  // Inspection type field
  if (stateQuery.idaInspectionType != null) {
    searchBody.query.bool.must.push({match_phrase: {inspectionType: stateQuery.idaInspectionType}})
  }

  // Scheduled by field
  if (stateQuery.idaScheduler != null) {
    searchBody.query.bool.must.push({match_phrase: {scheduledBy: stateQuery.idaScheduler}})
  }

  // Inspected by field
  if (stateQuery.idaInspector != null) {
    searchBody.query.bool.must.push({match_phrase: {inspectedBy: stateQuery.idaInspector}})
  }

  // Inspection Result field
  if (stateQuery.inspectionResult != null) {
    let should = []
    stateQuery.inspectionResult.forEach(x => should.push({match_phrase: {inspectionResult: x}}))
    if (should.length > 0) {
      searchBody.query.bool.must.push({bool: {should: should}})
    }
  }

  if (stateQuery.requestedInspectionDate != null) {
    searchBody.query.bool.filter.push(dateBetween(stateQuery.requestedInspectionDate, "requestedInspectionDate"))
  }

  if (stateQuery.dateScheduled != null) {
    searchBody.query.bool.filter.push(dateBetween(stateQuery.dateScheduled, "dateScheduled"))
  }

  if (stateQuery.actualInspectionDate != null) {
    searchBody.query.bool.filter.push(dateBetween(stateQuery.actualInspectionDate, "actualInspectionDate"))
  }

  return searchBody
}
